'use client';
import { useEffect } from 'react';
import { clarity } from 'react-microsoft-clarity';

const ClarityInitializer = () => {
    useEffect(() => {
        // Initialize Clarity here
        clarity.init(process.env.APP_CLARITY_KEY || '');
    },[])
  return null
}

export default ClarityInitializer